const DAY_MS = 1000 * 60 * 60 * 24;
const DUE_SOON_DAYS = 30;

// Same day count as the insurance filter in MyCars.jsx, so the counts match what the filter shows
const daysUntil = (value, now) => {
    if (!value || value === 'N/A') return null;
    const time = new Date(value).getTime();
    if (Number.isNaN(time)) return null;
    return Math.ceil((time - now.getTime()) / DAY_MS);
};

/**
 * Totals for the cars currently in view (after tab, search and filters).
 * @param {Array<Object>} cars - Mapped car rows from MyCars.jsx
 * @param {Date} [now]
 * @param {Object<string, number>|null} [weeklyInvoices] - This week's WAI net amount per plate; null while not loaded
 * @returns {{vehicleCount: number, outstanding: {total: number, count: number}, insurance: {expired: number, expiring: number}, inspection: {overdue: number, dueSoon: number}, coverage: ({pct: number|null, net: number, invoiced: number}|null)}}
 */
export const summarizeCars = (cars = [], now = new Date(), weeklyInvoices = null) => {
    const summary = {
        vehicleCount: cars.length,
        outstanding: { total: 0, count: 0 },
        insurance: { expired: 0, expiring: 0 },
        inspection: { overdue: 0, dueSoon: 0 },
        coverage: null
    };
    let net = 0;
    let invoiced = 0;

    cars.forEach((car) => {
        const balance = parseFloat(car.actual_bal) || 0;
        net += balance;
        if (weeklyInvoices) invoiced += Number(weeklyInvoices[car.plate_no]) || 0;
        if (balance > 0) {
            summary.outstanding.total += balance;
            summary.outstanding.count += 1;
        }

        const insuranceDays = daysUntil(car.insurer_expiry, now);
        if (insuranceDays !== null) {
            if (insuranceDays < 0) summary.insurance.expired += 1;
            else if (insuranceDays <= DUE_SOON_DAYS) summary.insurance.expiring += 1;
        }

        const inspectionDays = daysUntil(car.next_government_inspection_due, now);
        if (inspectionDays !== null) {
            if (inspectionDays < 0) summary.inspection.overdue += 1;
            else if (inspectionDays <= DUE_SOON_DAYS) summary.inspection.dueSoon += 1;
        }
    });

    const round2 = (n) => Math.round(n * 100) / 100;
    summary.outstanding.total = round2(summary.outstanding.total);
    // Same formula as Weekly Coverage on the homepage (home.jsx): net balance, credits included,
    // as a share of this week's invoices; here limited to the cars in view
    if (weeklyInvoices) {
        summary.coverage = { pct: invoiced > 0 ? round2((net / invoiced) * 100) : null, net: round2(net), invoiced: round2(invoiced) };
    }
    return summary;
};
